import { render, staticRenderFns } from "./CampaignPointsFormPage.vue?vue&type=template&id=5bd52a2b&"
import script from "./CampaignPointsFormPage.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports